export default function convertCMSDateToEpoch(dateString) {
  // when date gets queried from CMS/.md file an "Z" gets appended, setting the date to UTC+0 without converting it, thus creating a timezone error
  if (dateString.slice(-1) === "Z") dateString = dateString.slice(0, -1);

  const date = new Date(dateString);

  return date.getTime();
}
